import styled from 'styled-components'

const data = [
    {
        name: 'Sort',
        dropdownData: [
            'Recommended',
            'Whats new',
            'Price high to Low',
            'Price low to high',
        ],
    },
    {
        name: 'Sort',
        dropdownData: [
            'Recommended',
            'Whats new',
            'Price high to Low',
            'Price low to high',
        ],
    },
    {
        name: 'Sort',
        dropdownData: [
            'Recommended',
            'Whats new',
            'Price high to Low',
            'Price low to high',
        ],
    },
]

const Filters = () => {
    return (
        <StyledFilters>
            {data.map((filter) => (
                <div className="dropdown">
                    <div className="head">
                        <p>{filter.name}</p>
                        <img src="/images/primary/arrow.svg" alt="" />
                    </div>
                    <div className="dropdown_data">
                        {filter.dropdownData.map((data) => (
                            <div className="row">{data}</div>
                        ))}
                    </div>
                </div>
            ))}
        </StyledFilters>
    )
}

export default Filters

const StyledFilters = styled.div`
    margin-bottom: 60px;
    display: grid;
    grid-template-columns: repeat(5, 200px);
    grid-gap: 10px;

    .head {
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        height: 42px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        padding: 3px 20px 3px 6px;
    }

    .dropdown {
        position: relative;
    }

    .dropdown_data {
        display: none;
        position: absolute;
        z-index: 1000;
        width: 356px;
        padding: 10px;
        background-color: #eee;
        box-shadow: 0 5px 13px -2px rgb(0 0 0 / 80%);
    }

    .row {
        background: #ffffff;
        padding: 0 14px;
        height: 44px;
        cursor: pointer;
        display: flex;
        align-items: center;
        border-radius: 5px;
        &:nth-child(n + 2) {
            margin-top: 10px;
        }
    }
`
